import React from 'react';
import { SmallText } from 'ds/components/typography';
import { useScreenBreakpoint } from 'consts/breakpoints';
import * as Styled from './styled';
import { Images } from '../../sections/gallery';
import { routeByPoiType } from 'utils/marketplaceRoutes';
import { Link } from 'components/link';

export const ImageInfo: React.FC<Images> = (props) => {
  const { address, id, dealType, bulletinType } = props;
  const isMobile = useScreenBreakpoint() === 1;

  if (!address && !isMobile) return null;

  const content = <SmallText weight={isMobile ? 'normal' : 'medium'}>{address}</SmallText>;
  return (
     <Styled.ImageInfoRoot>
      <Link routeName={routeByPoiType(bulletinType)} routeParams={{ id, dealType }}>{content}</Link>
    </Styled.ImageInfoRoot>
  );
};
